module.exports = __webpack_public_path__ + "static/media/recharge_help2.5327dab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/recharge_help2.png
// module id = 3834
// module chunks = 1